import BarraMenu from "../../../components/BarraMenu";
import useDigitalTheme from "../../hooks/useDigitalTheme";
import { Accordion } from "react-bootstrap";
import FormularioPropiedadesPerfiles from "./FormularioPropiedadesPerfiles";
import FormularioPropiedadesClientes from "./FormularioPropiedadesClientes";
import FormularioPropiedadesEstados from "./FormularioPropiedadesEstados";
import FormularioPropiedadesCategories from "./FormularioPropiedadesCategories";
import FormularioPropiedadesUserJob from "./FormularioPropiedadesUserJob";
import FormularioPropiedadesEmpresas from "./FormularioPropiedadesEmpresas";
import "./style.css";

const AdministracionParametrosPage = () => {
  useDigitalTheme();
  return (
    <div className="params-page">
      <BarraMenu />
      <div className="container py-3">
        <div className="params-breadcrumb">
          Home / Administración / Parámetros del sistema
        </div>

        {/* 1. CLIENTES */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>CLIENTES</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesClientes />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 2. EMPRESAS DEL GRUPO */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>EMPRESAS DEL GRUPO</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesEmpresas />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 3. CARGOS */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>CARGOS</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesUserJob />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 4. ESTADOS */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>ESTADOS</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesEstados />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 5. PERFILES */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>PERFILES</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesPerfiles />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </div>
    </div>
  );
};

export default AdministracionParametrosPage;